/*
 * Copyright (c) Vaisala Oyj. All rights reserved.
 */
import * as React from 'react';
import { Button, ButtonType, Icon, Size } from '@vaisala/rockhopper-components';
import { VaiColor, VaiIcon } from '@vaisala/rockhopper-design-tokens';
import { useTranslation } from 'react-i18next';
import './MainBanner.scss';
import { openInNewTab } from '../../utils/link';
import Analytics from '../../modules/analytics/Analytics';
import localizedBanner from '../../i18n/localizedBanner.json';

interface MainBannerProps {
  variant: 'mobile' | 'desktop' | 'tablet';
}

interface Keyable {
  [key: string]: any;
}

const MainBanner = ({ variant }: MainBannerProps) => {
  const { t, i18n } = useTranslation();
  const banner: Keyable = localizedBanner;
  const [url, setUrl] = React.useState<string>('');
  const [bgStyle, setBgStyle] = React.useState<Keyable>({});
  const lang = i18n.language;

  const onBannerAction = (link: string) => {
    Analytics.log('navigation.banner', link);
    if (link.includes('mailto')) {
      window.location.href = link;
    } else {
      openInNewTab(link);
    }
  };

  React.useEffect(() => {
    if (banner && lang && variant) {
      let formatLang = lang;
      if (lang.includes('-')) {
        formatLang = lang.split('-')[0];
      }
      if (lang && Object.keys(banner).includes(formatLang)) {
        setUrl(banner[formatLang].link);
        setBgStyle({ backgroundImage: `url(${process.env.PUBLIC_URL}/${banner[formatLang]?.bg.source}` });
      }
    }
  }, [banner, variant, lang]);

  // Button and background effect disabled for the feedback form. 12.5.2023 Joni
  return (
    <div className={`main-banner-wrap ${variant}`}>
      <div className="main-banner" style={bgStyle} onClick={() => onBannerAction(url)}>
        {/* <div className="bg-highlight" />
        <div className="content">
          <Icon name={VaiIcon.VaisalaLogoLarge} size={Size.S} color={VaiColor.White} />
          <p className="vai-body-text" dangerouslySetInnerHTML={{ __html: t('banner.body') }} />
          <Button buttonType={ButtonType.Primary} buttonSize={Size.M} onClick={() => onBannerAction(url)}>
            {t('banner.button')}
          </Button>
        </div> */}
      </div>
    </div>
  );
};
export default MainBanner;
